import React from "react";

const ModalFooter = (props) => {
    const {
        buttonLabel,
        onButtonClick,
        buttonDisabled,
        closeButtonLabel,
        onClose,
        closeButtonRef,
        secondaryButtonLabel,
        onSecondaryButtonClick,
        secondaryButtonDisabled
    } = props;
    return (
        <footer
            className="min-h-[4rem] flex flex-wrap flex-row-reverse items-center border-secondary border-t px-6 py-2 gap-3 bg-inverse">
            {(!!buttonLabel || !!closeButtonLabel) && (
                <div>
                    {!!buttonLabel && (
                        <button
                            className={`btn btn-primary mr-2`}
                            onClick={() => {
                                if (!buttonDisabled) {
                                    onButtonClick();
                                }
                            }}
                            disabled={!!buttonDisabled}
                        >
                            {buttonLabel}
                        </button>
                    )}

                    {!!closeButtonLabel && (
                        <button
                            className="btn btn-outline"
                            onClick={() => {
                                onClose();
                            }}
                            ref={closeButtonRef}
                        >
                            {props.closeButtonLabel}
                        </button>
                    )}
                </div>
            )}

            <span className="flex mr-auto">
                {!!secondaryButtonLabel && (
                    <button
                        className={'btn btn-outline mr-auto'}
                        onClick={() => {
                            if (!secondaryButtonDisabled) {
                                onSecondaryButtonClick();
                            }
                        }}
                        disabled={!!secondaryButtonDisabled}
                    >
                        {secondaryButtonLabel}
                    </button>
                )}

                {props.children}
            </span>
        </footer>
    )
}

export default ModalFooter;
